module.exports = __webpack_public_path__ + "static/media/prl.0c0cb806.png";